var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value
    ? _c("div", { staticClass: "article-metadata-content" }, [
        _vm.label
          ? _c("span", { staticClass: "article-metadata-info" }, [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }